'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var App = require('app');
var Company = require('models/company');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var PermissionDialogView = require('components/profile/views/company_permissions_dialog_view');

var AdminUserView = AbstractTableView.extend({
    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click .js-company-user': 'changeUserPermissions',
            'click .js-add': 'addNewUser',
        });
    },

    collectionEvents: {
        sync: 'render',
    },

    initialize: function (options) {
        this.controller = options.controller;

        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('Administratoren'),
                headingID: 'admins',
                columns: [
                    { id: '#_name', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
                    { id: '#_ViewBilling', name: 'Rechnungen' }, // i18n.TR('Rechnungen')
                    { id: '#_ManageUsers', name: 'Nutzer' }, // i18n.TR('Nutzer')
                    { id: '#_EditDevices', name: 'Geräte' }, // i18n.TR('Geräte')
                ],
                customButtons: [
                    {
                        ButtonIcon: 'fa fa-plus',
                        ButtonID: 'add',
                    },
                ],
                hasRefreshButton: true,
                hasSelectionButtons: true,
                selectionButtons: [{ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' }],
            },
        ]);
    },

    changeUserPermissions: function (e) {
        e.preventDefault();
        App.showModal(
            new PermissionDialogView({
                model: this.collection.get(e.currentTarget.id),
                newUser: false,
            })
        );
    },

    addNewUser: function (e) {
        e.preventDefault();
        App.showModal(
            new PermissionDialogView({
                model: new Company.User({ permissions: [] }),
                newUser: true,
            })
        );
    },

    initializeCustomSorting: function () {
        Misc.sortTableByEmail($('th#h-Name'));
    },
});

module.exports = AdminUserView;
